import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useEffect, useState } from "react";

/**
 * Choose the rate type before converting an application to an agreement.
 * Mirrors the backend rule (lib/rateType): balloon loans are always fixed,
 * everything else defaults to fixed but may be made variable.
 */
export const ConvertToAgreementDialog = ({
  open,
  onClose,
  onConfirm,
  application,
  saving,
}) => {
  const balloon = (application?.balloon ?? 0) > 0;
  const [fixedRate, setFixedRate] = useState(true);

  useEffect(() => {
    if (open) {
      setFixedRate(balloon || (application?.fixedRate ?? true));
    }
  }, [open, balloon, application?.fixedRate]);

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Convert to agreement</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Choose the rate type for the new agreement. This cannot be changed
          once the agreement has been created.
        </Typography>
        <FormControl disabled={balloon || saving}>
          <RadioGroup
            value={fixedRate ? "fixed" : "variable"}
            onChange={(e) => setFixedRate(e.target.value === "fixed")}
          >
            <FormControlLabel
              value="fixed"
              control={<Radio />}
              label="Fixed rate — the rate is held for the life of the loan"
            />
            <FormControlLabel
              value="variable"
              control={<Radio />}
              label="Variable rate — rescheduled whenever the base rate changes"
            />
          </RadioGroup>
          {balloon && (
            <FormHelperText>
              Balloon agreements are always fixed rate.
            </FormHelperText>
          )}
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          loading={saving}
          onClick={() => onConfirm({ fixedRate })}
        >
          Convert
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
